import { ITax, ITaxType } from '../../../interfaces/ITaxes';
import { calculateInclusiveTaxes, calculateAdditiveTaxes, getTaxesType } from '../../../utils/TaxController';

const SET_PRICING_OPTION = 'SET_PRICING_OPTION';
const SET_TAXES_ITEMS = 'SET_TAXES_ITEMS';
const SET_TAXES_PRICING = 'SET_TAXES_PRICING';

export function setPricingOption(price: number) {
    return {
        type: SET_PRICING_OPTION,
        payload: price,
    };
}

export function setTaxItems(taxes: ITax[]) {
    return {
        type: SET_TAXES_ITEMS,
        payload: taxes,
    };
}

export function setTaxPrice(price: number) {
    return {
        type: SET_TAXES_PRICING,
        payload: price,
    };
}

interface IPricingOptionsState {
    taxes?: ITax[];
    option_price: number;
    option_price_exclusive: number;
    taxType?: ITaxType;
}

export function PricingOptionsReducer(state: IPricingOptionsState, action: { type: string; payload: any }) {
    switch (action.type) {
        case SET_PRICING_OPTION:
            const tax = state.taxes;
            let option_price_exclusive = state.option_price_exclusive;
            const pricing_options = action.payload;
            if (state.taxType === ITaxType.INCLUSIVE) {
                const taxAmountPo = calculateInclusiveTaxes(tax!, pricing_options);
                option_price_exclusive = +(pricing_options - taxAmountPo).toFixed(2);
            }
            return {
                ...state,
                option_price: pricing_options,
                option_price_exclusive,
            };
        case SET_TAXES_PRICING:
            const taxes = state.taxes;
            const price_exclusive = action.payload;
            let price_ops = state.option_price;
            if (state.taxType === ITaxType.ADDITIVE) {
                const taxAmountPo = calculateAdditiveTaxes(taxes!, price_exclusive);
                price_ops = +(price_exclusive + taxAmountPo).toFixed(2);
            }
            return {
                ...state,
                taxes,
                option_price: price_ops,
                option_price_exclusive: price_exclusive,
            };
        case SET_TAXES_ITEMS:
            const taxItems = action.payload;
            const taxType = getTaxesType(taxItems);
            const lastTaxType = state.taxType;

            let option_price_e = state.option_price_exclusive ?? 0;
            let price = state.option_price ?? 0;
            /**
             * If price is a number or
             * price is a string and greater than 0
             * then we do subtracting calc
             */
            if (
                price &&
                (typeof price === 'number' ||
                    //@ts-ignore
                    (typeof price === 'string' && price.length > 0))
            ) {
                const oPrice = typeof price === 'number' ? price : parseFloat(price);
                const ePrice = typeof option_price_e === 'number' ? option_price_e : parseFloat(option_price_e);

                if (taxType === ITaxType.ADDITIVE) {
                    const taxAmount = calculateAdditiveTaxes(taxItems, ePrice);
                    price = parseFloat((ePrice + taxAmount).toFixed(2));
                } else if (taxType === ITaxType.INCLUSIVE) {
                    const taxAmount = calculateInclusiveTaxes(taxItems, oPrice);
                    option_price_e = parseFloat((oPrice - taxAmount).toFixed(2));
                }
            }
            if (taxItems.length === 0) {
                /**Resets the pricing fields when no tax options are selected */
                if (lastTaxType) {
                    if (lastTaxType === ITaxType.ADDITIVE) {
                        price = option_price_e;
                    } else {
                        option_price_e = price;
                    }
                } else {
                    option_price_e = price;
                }
            }
            return {
                ...state,
                taxes: taxItems,
                taxType,
                option_price: price,
                option_price_exclusive: option_price_e,
            };
        default:
            return {
                ...state,
            };
    }
}
